export const FEATURE_FLAG_NAMES = {
  GES_EUROZONE_SINGAPORE_COMPLIANCE: "GES_EUROZONE_SINGAPORE_COMPLIANCE",
};
